import Link from 'next/link';
import { useRouter } from 'next/router';
import React, { ChangeEvent, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setErrorMessages, signUpUser } from '../../redux/user/user.actions';
import ErrorAlert from '../tailwind/alerts/error-alert.component';
import { Footer } from '../newhome/Footer'
import { Header } from '../newhome/Header'
import ContentModal from '../tailwind/modals/content-modal';
import TermsOfServiceContent from '../terms-of-service/terms-of-service-content.component';
import sendRequest from '../../utils/useAxios';

const optionsList = [
  {
    name: "Please! select any option",
  },
  {
    value: "google",
    name: "Google"
  },
  {
    value: "youtube",
    name: "YouTube"
  },
  {
    value: "facebook",
    name: "Facebook"
  },
  {
    value: "personalRecommendation",
    name: "Personal Recommendation"
  },
  {
    value: "other",
    name: "Other"
  },
]


const SignupPage = () => {
  const router = useRouter();
  const dispatch = useDispatch();
  const { errorMessages } = useSelector((state: any) => state.user);

  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [company, setCompany] = useState('');
  const [password, setPassword] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [agreeTerms, setAgreeTerms] = useState(false);
  const [loading, setLoading] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState('');
  const [displayTermsPopup, setDisplayTermsPopup] = useState(false);
  const [pricingPlan, setPricingPlan] = useState()
  const [selectedPlan, setSelectedPlan] = useState('');
  const [source, setSource] = useState("");
  const [otherValue, setOtherValue] = useState("");
  const [newValue, setNewValue] = useState("");

  useEffect(() => {
    if(router.isReady){

      if(!router) return
      if (router.query?.plan) {
        const { plan } = router.query
        setSelectedPlan(plan)
      } else if (localStorage.getItem('PRICING_PLAN')) {
        const plan = localStorage.getItem('PRICING_PLAN')
        setSelectedPlan(plan)
      } 
      else {
        router.push('https://servicecart.io/pricing-page');
      }
      dispatch(setErrorMessages([]));
    }
  }, [router]);

  async function checkUsPhoneValidation(phoneNumber: string) {
    setLoading(true)
    if (phoneNumber) {
      let phoneWithCountryCode = '';
      phoneWithCountryCode = '1' + phoneNumber;
      const { data } = await sendRequest(
        'GET',
        `/leads/checkIsValidPhoneAndEmail?email=${email}&phone=${phoneWithCountryCode}`
      );
      if (!data?.valid) {
        dispatch(setErrorMessages([data?.message]));
        setLoading(false);
        return false;
      }
      return true
    }
  }


  async function getPricingPlan() {
    const { data } = await sendRequest('GET', `/pricing-plan/planByName/${selectedPlan}`)
    if(data){

      setPricingPlan(data._id)
    }
    else{
      router.push('https://servicecart.io/pricing-page');
    }
  } 
  const isCorrectName=(name)=>{
    const plans=['Professional','Performance','Premium']
    return plans.includes(name)
  }

  useEffect(() => {
    if (selectedPlan) {
      if(isCorrectName(selectedPlan)){
        getPricingPlan()
      }
      else{
        router.push('https://servicecart.io/pricing-page');
      }
    }
  }, [selectedPlan])

  useEffect(() => {
    if (errorMessages.length > 0) setLoading(false);
  }, [errorMessages]);

  const onClickedSignup = async (e: any) => {

      e.preventDefault();
      phoneNumber.trim()
      if(!phoneNumber){
        // setErrorMessages(['Please enter phone number'])
        dispatch(setErrorMessages(['Please enter phone number']));
        return
      }
      if(!(phoneNumber.match('[0-9]'))){
        dispatch(setErrorMessages(['Phone number is not valid.']));
        return
        //  setErrorMessages(['Phone number is not valid.']);
        }
        // if(checkUsPhoneValidation(phoneNumber)){

        // }
        if(!source){
          dispatch(setErrorMessages(['Please select a source.']));
          return
        }
        if(!agreeTerms){
          dispatch(setErrorMessages(['Please check the Terms and condition.']));
          return
        }
      const isUsPhoneNumber = await checkUsPhoneValidation(phoneNumber)
      if (!isUsPhoneNumber) return
    const user = {
      name,
      email,
      phoneNumber,
      username: email.split('@')[0],
      company,
      roles: 'UNPAIDCUSTOMER',
      password,
      source,
      agreedTerms: agreeTerms,
      pricingPlan,
      signupEnabled: process.env.NEXT_PUBLIC_ENVIRONMENT === 'production' || process.env.NEXT_PUBLIC_ENABLE_SIGNUP === 'true'
    };

    dispatch(signUpUser(user, router));
  };

  const onSelectedOptions = (e: any) => {
    setSource(e.target.value);
    setOtherValue(e.target.value);
  }

  const onOtherField = (e: any) => {
    const { value } = e.target;
    const regex = /[!@#$%^&*()_+\-=[\]{};':"\\|<>/0-9]/;
    const isNotValid = regex.test(value);
    if(value.length >= 50){
      return;
    }if(isNotValid){
      return;
    }
    else{
      setNewValue(value)
      setSource(value)
    }
  }
  
  const onPhoneNumberChange = (e: any) => {
    var pattern = /\s/;
    if (pattern.test(e.target.value)) {
      return; // If space is found, exit the function without setting the phone number
    }
    if (isNaN(e.target.value)) {
      return; // If input is not a number, exit the function without setting the phone number
    }
    setPhoneNumber(e.target.value); // Set the phone number
  }

  return (
    <>
      {
        displayTermsPopup && (
          <ContentModal onClose={() => setDisplayTermsPopup(false)} maxWidth='max-w-6xl'>
            <TermsOfServiceContent />
          </ContentModal>
        )
      }
      <Header />
      <main className="min-h-screen bg-gray-100 flex flex-col justify-start sm:px-6 lg:px-8">
        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-md">
          <h2 className="text-center text-3xl text-gray-900">Create an account</h2>
          <p className="mt-2 text-center text-sm text-gray-600 max-w">
            Already have an account?{' '}
            <Link href="/sign-in">
              <a className="font-medium text-amber-500 hover:text-blue-400">Sign in</a>
            </Link>
          </p>
        </div>

        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
            <form className="space-y-6" onSubmit={onClickedSignup}>
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700">
                  Name
                </label>
                <div className="mt-1">
                  <input
                    id="name"
                    name="name"
                    type="text"
                    value={name}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => setName(e.target.value)}
                    required
                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-400 focus:border-blue-400 sm:text-sm"
                  />
                </div>
              </div>

              <div>
                <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                  Company
                </label>
                <div className="mt-1">
                  <input
                    id="company"
                    name="company"
                    type="text"
                    value={company}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => setCompany(e.target.value)}
                    required
                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-400 focus:border-blue-400 sm:text-sm"
                  />
                </div>
              </div>

              <div>
                <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                  Email
                </label>
                <div className="mt-1">
                  <input
                    id="email"
                    name="email"
                    type="email"
                    value={email}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
                    required
                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-400 focus:border-blue-400 sm:text-sm"
                  />
                </div>
              </div>

              <div>
                <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                  Phone number
                </label>
                <div className="mt-1">
                  <input
                    id="phoneNumber"
                    name="phoneNumber"
                    type="text"
                    value={phoneNumber}
                    onChange={onPhoneNumberChange}
                    required
                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-400 focus:border-blue-400 sm:text-sm"
                  />
                </div>
              </div>

              <div>
                <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                  Password
                </label>
                <div className="mt-1">
                  <input
                    id="password"
                    name="password"
                    type="password"
                    value={password}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)}
                    required
                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-400 focus:border-blue-400 sm:text-sm"
                  />
                </div>
              </div>

              <div>
                <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                  Confirm Password
                </label>
                <div className="mt-1">
                  <input
                    type="password"
                    value={confirmPassword}
                    onChange={(e: ChangeEvent<HTMLInputElement>) =>
                      setConfirmPassword(e.target.value)
                    }
                    required
                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-400 focus:border-blue-400 sm:text-sm"
                  />
                </div>
              </div>

              <div>
              <label className="block text-sm font-medium text-gray-700">
                How did you here about us?
                </label>
                <div className="mt-1">
                  <div >
                    <select required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" onChange={(e) => onSelectedOptions(e)}>
                      {optionsList?.map((op, i) => (
                        <option selected={op.name === "Please! select any option" ? true : false} disabled={op.name === "Please! select any option" ? true : false} key={i} value={op.value}>{op.name}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              {otherValue === "other" &&
                <div>
                  <input type='text' placeholder='Please! enter your reason' value={newValue} onChange={(e) => onOtherField(e) } className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" />
                </div>
              }

              <div className="mb-6">
                <div className="flex">
                  <div>
                    <input
                      className="mr-2 leading-tight"
                      type="checkbox"
                      checked={agreeTerms}
                      onChange={(e: ChangeEvent<HTMLInputElement>) => setAgreeTerms(!agreeTerms)}
                    />
                  </div>
                  <div className='mt-auto'>
                    <label className="text-gray-500 font-bold">
                      <div className="text-sm">
                        I agree to 
                        <span className='text-blue-500 cursor-pointer' onClick={() => setDisplayTermsPopup(true)}>
                          {" "}Terms and Conditions
                        </span>
                      </div>
                    </label>
                    </div>
                  </div>
              </div>

              {errorMessages && errorMessages.length > 0 && (
                <ErrorAlert errorMessages={errorMessages} />
              )}

              <div>
                <button
                  type="submit"
                  disabled={loading}
                  className={`w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white ${
                    loading
                      ? 'bg-indigo-300 hover:bg-indigo-300 cursor-default'
                      : 'bg-amber-500 hover:bg-blue-400'
                  } focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500`}
                >
                  {loading ? 'Loading' : 'Sign up'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default SignupPage;
